/**
 * 功能: 厂牌选择组件
 */
<template lang="pug">
  #auto-complete
    el-select(
      class="inline-input"
      :value="brand"
      :placeholder="placeholder"
      :loading="loading"
      loading-text='加载中，请稍后...'
      :disabled="disabled"
      clearable
      filterable
      :size="GLOBAL.SIZE_OF_INPUTBOX"
      @focus='getTeam'
      @change="getBrandInfo"
    )
      el-option(v-for='item in teamData' :key='item._id' :label='item.name' :value='item._id')
</template>

<script>
import Team from '@/apis/team'
export default {
  name: 'brandSelect',
  /**
   * @param placeholder   说明文字
   * @param removeDup     返回数据是否需要去重(Boolean)
   * @param disabled      选择框是否禁用
   * @param brand         组件绑定的值，即厂牌的id
   * @param brandName     厂牌名称
   */
  props: {
    placeholder: String,
    removeDup: {
      type: Boolean,
      default: false
    },
    disabled: { type: Boolean, default: false },
    brand: {
      type: String,
      default: ''
    },
    brandName: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'brand',
    event: 'change'
  },
  data () {
    return {
      teamData: [], // 厂牌列表
      loading: false, // 是否正从远程获取数据
      firstGet: true // 是否为第一次加载厂牌数据
    }
  },
  methods: {
    // 获取厂牌列表，第一次聚焦选择框的时候才会请求
    getTeam () {
      // 是否已请求过数据
      if (!this.firstGet) return
      this.loading = true
      Team.getTeamPage({ currentPage: 1, pageSize: 2000 }).then(r => {
        this.teamData = r.data.data
        if (this.removeDup) {
          this.teamData = this.unique(r.data.data)
        }
        this.loading = false
        this.firstGet = false
      })
    },
    getBrandInfo (brandId) {
      // 向父组件传值,父组件监听change,实现v-model
      this.$emit('change', brandId)
      const teamInfo = this.teamData.find(val => val._id === brandId)
      const brandName = teamInfo ? teamInfo.name : ''
      // 向父组件传递厂牌名字
      this.$emit('brandName', brandName)
    },
    // 数据去重
    unique (arr) {
      const hash = {}
      const newArr = arr.reduce((current, next) => {
        if (!hash[next._id]) {
          hash[next._id] = true
          current.push(next)
        }
        return current
      }, [])
      return newArr
    }
  },
  watch: {
    brand: {
      handler () {
        // 初始化选择器，用于编辑时回显已选择的厂牌
        if (this.firstGet && this.brand) {
          this.teamData = [{
            _id: this.brand,
            name: this.brandName
          }]
        }
      },
      immediate: true
    }
  }
}
</script>

<style>
#auto-complete .el-select {
  width: 100%;
}
</style>
